import { Component,Input, ElementRef } from '@angular/core';

@Component({
  selector: 'co-screen-row',
  templateUrl: 'co-screen-row.html'
})
export class CoScreenRowComponent {
  @Input() row: any = {};
  @Input() css: any = {};

  text: string;

  constructor(private el:ElementRef) {

  }
  ngAfterViewInit(){
    if(this.css){
      Object.keys(this.css).forEach((key) => {
        let value = this.css[key];
        //this.el.nativeElement.style[key]=value;
        this.el.nativeElement.style.setProperty(key, value, 'important');
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/co-screen-row/co-screen-row.ts